import {alias, createModelSchema, list} from "serializr";

import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {SmartOfferBundleNoviceBattlePassDay} from "@/modules/redactor/models/smart-offer/bundle-novice-battle-pass/SmartOfferBundleNoviceBattlePassDay";
import {RewardTrack} from "@/modules/redactor/models/reward/RewardTrack";

export class SmartOfferBundleNoviceBattlePass extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.NOVICE_BATTLE_PASS);
        this._rewards = null;
        this._rewards_premium = null;
        this._days = null;
    }
    get rewards() {
        return this._rewards;
    }
    set rewards(value) {
        this._rewards = value;
    }

    get rewards_premium() {
        return this._rewards_premium;
    }
    set rewards_premium(value) {
        this._rewards_premium = value;
    }

    get days() {
        return this._days;
    }
    set days(value) {
        this._days = value;
    }

    valid() {

        if (!super.valid()) {
            return false;
        }

        if (!this.rewards || this.rewards.empty()) {
            return false;
        }

        if (this.rewards && !this.rewards.valid()) {
            return false;
        }

        if (!this.days || this.days.length === 0) {
            return false;
        }

        if (this.days && this.days.some(v => !v || !v.valid())) {
            return false;
        }

        if (!this.rewards_premium || this.rewards_premium.empty()) {
            return false;
        }

        if (this.rewards_premium && !this.rewards_premium.valid()) {
            return false;
        }

        if (this.rewards.length != this.rewards_premium.length) {
            return false;
        }

        return true;
    }

    empty() {

        if (!this.rewards || this.rewards.empty()) {
            return true;
        }

        if (!this.rewards_premium || this.rewards_premium.empty()) {
            return true;
        }

        if (!this.days || this.days.empty()) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleNoviceBattlePass());
        } else if (target instanceof SmartOfferBundleNoviceBattlePass) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleNoviceBattlePass, {
    _rewards: alias("rewards", RewardTrack.schema()),
    _rewards_premium: alias("rewards_premium", RewardTrack.schema()),
    _days: alias("days", list(SmartOfferBundleNoviceBattlePassDay.schema())),
});

